// 한국 행정구역 데이터 (간소화 버전)
// 실제 앱에서는 전체 데이터를 로드하거나 API에서 가져와야 함

export interface RegionNode {
  code: string;
  name: string;
  children?: RegionNode[];
}

// 시/도 데이터
export const sidoData: RegionNode[] = [
  { code: "11", name: "서울특별시" },
  { code: "26", name: "부산광역시" },
  { code: "27", name: "대구광역시" },
  { code: "28", name: "인천광역시" },
  { code: "29", name: "광주광역시" },
  { code: "30", name: "대전광역시" },
  { code: "31", name: "울산광역시" },
  { code: "36", name: "세종특별자치시" },
  { code: "41", name: "경기도" },
  { code: "42", name: "강원도" },
  { code: "43", name: "충청북도" },
  { code: "44", name: "충청남도" },
  { code: "45", name: "전라북도" },
  { code: "46", name: "전라남도" },
  { code: "47", name: "경상북도" },
  { code: "48", name: "경상남도" },
  { code: "50", name: "제주특별자치도" },
];

// 경기도 시/군/구 데이터 (예시)
export const gyeonggiSigunguData: RegionNode[] = [
  { code: "41110", name: "수원시 장안구" },
  { code: "41130", name: "수원시 권선구" },
  { code: "41140", name: "수원시 팔달구" },
  { code: "41150", name: "수원시 영통구" },
  { code: "41270", name: "성남시 수정구" },
  { code: "41280", name: "성남시 중원구" },
  { code: "41290", name: "성남시 분당구" },
  { code: "41460", name: "용인시 처인구" },
  { code: "41461", name: "용인시 수지구" },
  { code: "41463", name: "용인시 기흥구" },
  { code: "41550", name: "부천시" },
  { code: "41570", name: "안양시 만안구" },
  { code: "41590", name: "안양시 동안구" },
  { code: "41610", name: "안산시 상록구" },
  { code: "41630", name: "안산시 단원구" },
  { code: "41650", name: "광명시" },
  { code: "41670", name: "평택시" },
  { code: "41690", name: "과천시" },
  { code: "41710", name: "오산시" },
  { code: "41730", name: "시흥시" },
  { code: "41750", name: "군포시" },
  { code: "41770", name: "의왕시" },
  { code: "41790", name: "하남시" },
  { code: "41810", name: "이천시" },
  { code: "41830", name: "김포시" },
  { code: "41850", name: "안성시" },
  { code: "41870", name: "고양시 덕양구" },
  { code: "41890", name: "고양시 일산동구" },
  { code: "41891", name: "고양시 일산서구" },
  { code: "41900", name: "구리시" },
  { code: "41920", name: "남양주시" },
  { code: "41940", name: "파주시" },
  { code: "41960", name: "양주시" },
  { code: "41980", name: "의정부시" },
  { code: "41990", name: "동두천시" },
  { code: "41465", name: "용인시 수지구" },
];

// 용인시 수지구 읍/면/동 데이터 (풍덕천동 등)
export const sujiDongData: RegionNode[] = [
  { code: "41465101", name: "풍덕천동" },
  { code: "41465102", name: "수지동" },
  { code: "41465103", name: "상현동" },
  { code: "41465104", name: "성복동" },
  { code: "41465105", name: "동천동" },
  { code: "41465106", name: "죽전동" },
  { code: "41465107", name: "고기동" },
];

// 서울특별시 시/군/구 데이터
export const seoulSigunguData: RegionNode[] = [
  { code: "11110", name: "종로구" },
  { code: "11120", name: "중구" },
  { code: "11130", name: "용산구" },
  { code: "11140", name: "성동구" },
  { code: "11150", name: "광진구" },
  { code: "11160", name: "동대문구" },
  { code: "11170", name: "중랑구" },
  { code: "11180", name: "성북구" },
  { code: "11190", name: "강북구" },
  { code: "11200", name: "도봉구" },
  { code: "11210", name: "노원구" },
  { code: "11220", name: "은평구" },
  { code: "11230", name: "서대문구" },
  { code: "11240", name: "마포구" },
  { code: "11250", name: "양천구" },
  { code: "11260", name: "강서구" },
  { code: "11270", name: "구로구" },
  { code: "11280", name: "금천구" },
  { code: "11290", name: "영등포구" },
  { code: "11300", name: "동작구" },
  { code: "11310", name: "관악구" },
  { code: "11320", name: "서초구" },
  { code: "11330", name: "강남구" },
  { code: "11340", name: "송파구" },
  { code: "11350", name: "강동구" },
];

// 시/군/구 데이터 맵
export const sigunguMap: Record<string, RegionNode[]> = {
  "11": seoulSigunguData,
  "41": gyeonggiSigunguData,
  // 실제 앱에서는 모든 시/도의 시/군/구 데이터 필요
};

// 읍/면/동 데이터 맵 (실제 앱에서는 전체 데이터 필요)
export const dongMap: Record<string, RegionNode[]> = {
  "41465": sujiDongData, // 용인시 수지구
  // 실제 앱에서는 모든 시/군/구의 읍/면/동 데이터 필요
};

// 지역 코드로 이름 조회
export function getRegionName(code: string): string | undefined {
  // 시/도 검색
  const sido = sidoData.find(s => s.code === code);
  if (sido) return sido.name;

  // 시/군/구 검색
  for (const sigunguList of Object.values(sigunguMap)) {
    const sigungu = sigunguList.find(s => s.code === code);
    if (sigungu) return sigungu.name;
  }

  // 읍/면/동 검색
  for (const dongList of Object.values(dongMap)) {
    const dong = dongList.find(d => d.code === code);
    if (dong) return dong.name;
  }

  return undefined;
}